import { setTheme } from "theme/default/setTheme";

export const setColor_25476d = setTheme(({ theme }) => `color: ${theme.colors.color_25476d}`);
